import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js'

window.bootstrap = bootstrap
